<template>
  <div class="w-100 vh-100 d-flex justify-content-center align-items-center">
    <div class="col-md-6 col-lg-4">
      <transition name="fade">
        <div class="card card-body card-login" v-if="show">
          <div class="d-none d-md-flex justify-content-center">
            <router-link
              class="d-flex justify-content-center"
              :to="{name: 'home'}"
            >
              <img
                class="w-50"
                src="@/common/assets/img/logo.png"
                alt="commercialreview"
              />
            </router-link>
          </div>
          <hr class="d-none d-md-block"/>
          <v-login-form
            @authenticated="goToDashboard"
          />
          <hr/>

          <div class="d-flex justify-content-end align-items-center">
            <div>
              {{ $t('phrase.has_no_account') }}
            </div>
            <div>
              <v-register-dropdown
                style-type="link"
                @selected="routeTo"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import LoginForm from '@/common/components/auth/LoginForm.vue';
import RegisterDropdown from '@/common/components/auth/RegisterDropdown.vue';
import { mapGetters } from 'vuex';
import { notify } from '@/common/utils/notify';

export default {
  name: 'Login',
  data() {
    return {
      show: false,
    };
  },
  methods: {
    goToDashboard() {
      notify('phrase.logged_in', 'sentence.welcome_in_app');
      let routeName = 'dashboard';
      if (this.org !== null) {
        routeName = 'organisation-dashboard';
      }
      this.$router.push(this.$route.query.next || { name: routeName });
    },
    routeTo(registerAs) {
      this.$router.push({
        name: 'register-as',
        params: { as: registerAs },
        query: this.$route.query,
      });
    },
  },
  computed: {
    ...mapGetters(['org']),
    ...mapGetters(['authTokenExists']),
  },
  components: {
    'v-login-form': LoginForm,
    'v-register-dropdown': RegisterDropdown,
  },
  created() {
    if (this.authTokenExists) {
      if (this.$route.query.next) {
        document.location.href = this.$route.query.next;
      } else {
        this.$router.push({ name: 'dashboard' });
      }
      return;
    }
    setTimeout(() => {
      this.show = true;
    }, 200);
  },
};
</script>


<style scoped>
@media (max-width: 768px) {
  .card-login {
    padding-top: 89px;
    max-width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>
